"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Submission = exports.SubmissionType = void 0;
const runtypes_1 = require("runtypes");
const languages_1 = require("./languages");
const testtesting_1 = require("./testtesting");
exports.SubmissionType = (0, runtypes_1.Union)((0, runtypes_1.Literal)("SOLVE"), (0, runtypes_1.Literal)("TESTTESTING"));
exports.Submission = (0, runtypes_1.Record)({
    type: exports.SubmissionType,
    contentHash: runtypes_1.String,
    language: languages_1.Languages,
    contents: runtypes_1.String,
}).And((0, runtypes_1.Partial)({
    testTestingSettings: testtesting_1.TestTestingSettings,
}));
//# sourceMappingURL=submission.js.map